import Social1 from "../../../assets/icon/NewsIcons/NewsSocial1"
import Social2 from "../../../assets/icon/NewsIcons/NewsSocial2"
import Social3 from "../../../assets/icon/NewsIcons/NewsSocial3"
import Social4 from "../../../assets/icon/NewsIcons/NewsSocial4"
import Social5 from "../../../assets/icon/NewsIcons/NewsSocial5"
import Logo from "../../../assets/img/NewsImgs/newLogo.webp"
import { Link } from "react-router-dom"
const FooterLeft2 = () => {
    return(
        <div className="flex w-[100%] flex-col items-center justify-center mt-20 pl-8 md:w-full md:mt-2 md:pl-0">
            <div className="mb-5">
                <Link to={"/"}>
                    <img src={Logo} className="w-[180px] lg:w-[80px]"/>
                </Link>

            </div>
            <div className="flex justify-start items-center">
                <Link to={"/"} className="ml-4">
                    <Social1 color='#BD9F3F'/>
                </Link>
                <Link to={"/"} className="ml-4">
                    <Social5 color='#BD9F3F'/>
                </Link>
                <Link to={"/"} className="ml-4">
                    <Social4 color='#BD9F3F'/>
                </Link>
                <Link to={"/"} className="ml-4">
                    <Social3 color='#BD9F3F'/>  
                </Link>
                <Link to={"https://beta.bale.ai/chat?uid=5344147484"}>
                    <Social2 color='#BD9F3F'/>
                </Link>

            </div>
        </div>
    )
}

export default FooterLeft2;